import { Box, Tab, Tabs } from "@mui/material";
import { TabContext } from "@mui/lab";
import { useState } from "react";
import Header from "../../../components/Header";
import ContextLogTab from "./components/ContextLogTab";
import IncidentMapTab from "./components/IncidentMapTab";

const IncidentContext = ({ otEnabled = true }) => {
  const [tabValue, setTabValue] = useState("0");
  const [prefillIp, setPrefillIp] = useState(null);
  const [prefillDateFrom, setPrefillDateFrom] = useState(null);
  const [prefillDateTo, setPrefillDateTo] = useState(null);

  const handleOpenContextLog = (ip, dateFrom, dateTo) => {
    setPrefillIp(ip);
    setPrefillDateFrom(dateFrom ?? null);
    setPrefillDateTo(dateTo ?? null);
    setTabValue("1");
  };

  return (
    <Box m="20px" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Header
        title="Incident Analysis"
        subtitle="Context logs and host incident grouping"
        desc="Analyze security events around a specific host and time, or explore how incidents are distributed across hosts by severity."
      />
      <TabContext value={tabValue}>
        <Tabs onChange={(e, v) => setTabValue(v)} value={tabValue} centered>
          <Tab sx={{ fontSize: 15 }} label="Incident Map" value="0" />
          <Tab sx={{ fontSize: 15 }} label="Context Log" value="1" />
        </Tabs>
        <Box sx={{ display: tabValue === "0" ? "block" : "none" }}>
          <IncidentMapTab onOpenContextLog={handleOpenContextLog} otEnabled={otEnabled} />
        </Box>
        <Box sx={{ display: tabValue === "1" ? "block" : "none" }}>
          <ContextLogTab
            prefillIp={prefillIp}
            prefillDateFrom={prefillDateFrom}
            prefillDateTo={prefillDateTo}
            onPrefillConsumed={() => { setPrefillIp(null); setPrefillDateFrom(null); setPrefillDateTo(null); }}
            otEnabled={otEnabled}
          />
        </Box>
      </TabContext>
    </Box>
  );
};

export default IncidentContext;
